// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"107":"a89e31f3","826":"a89e31f3"}[chunkId] + ".chunk.css";
};